import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  LabelStyled,
  TextStyled,
} from "../../styled/Elements";
import { Col, Form, Modal, Row } from "react-bootstrap";
import ValidatedInput from "../../common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { SelectionDropdown } from "../../styled/FormElements";
import MultipleImageUpload from "../../../pages/web/profile/components/MultipleImagesUpload";
import PropertiesApi from "../../../services/api/propertiesApi";
import ValidationController from "../../common/inputFields/ValidationController";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import VisitorApi from "../../../services/api/visitorApi";
import CustomRadioButton from "../../common/radioButtons/CustomRadio";
import { countWords, formatAmountForDisplay } from "../../../utils";
import MultipleVideoUpload from "../../../pages/web/profile/components/MultipleVideoUpload";
import { uploadPropertyMediaFiles } from "../../../services/propertyMediaUpload";

const AddPropertyModal = (props) => {
  // const citiesJson = localStorage.getItem("citiesList");
  // const cities = citiesJson ? JSON.parse(citiesJson) : [];
  // const [loading, setLoading] = useState(false);
  // const [districts, setDistricts] = useState([]);

  // const [isUploading, setIsUploading] = useState(false);
  // const [uploadingType, setUploadingType] = useState(null);
  // const [progress, setProgress] = useState(0);
  // const [resetTrigger, setResetTrigger] = useState(0);

  // const mediaTypeCategoryMap = {
  //   exterior_images: { type: 1, category: 1 },
  //   interior_images: { type: 1, category: 2 },
  //   exterior_videos: { type: 2, category: 1 },
  //   interior_videos: { type: 2, category: 2 },
  // };

  // const {
  //   t,
  //   i18n: { language },
  // } = useTranslation();
  // const {
  //   register,
  //   control,
  //   handleSubmit,
  //   reset,
  //   watch,
  //   setValue,
  //   formState: { errors },
  // } = useForm();
  // const uploadSessionIdRef = useRef(null);
  // const abortControllersRef = useRef({});

  // const cityId = watch("city_id");
  // const priceInput = watch("price");
  // const propertyType = watch("listing_property_type_id");
  // const [propertyTypes, setPropertyTypes] = useState(null); // State: track uploaded file names per field
  // const [uploadedFilesMap, setUploadedFilesMap] = useState({
  //   interior_images: new Set(),
  //   exterior_images: new Set(),
  //   interior_videos: new Set(),
  //   exterior_videos: new Set(),
  // });

  // const handleClose = () => {
  //   setResetTrigger((prev) => prev + 1);
  //   Object.values(abortControllersRef.current).forEach((controller) => {
  //     controller.abort();
  //   });

  //   abortControllersRef.current = {}; // Reset the controllers
  //   uploadSessionIdRef.current = null; // Invalidate the current session
  //   reset(); // Reset form fields
  //   props.onHide(); // Close modal
  // };

  // const getPropertyTypes = async (type = 1) => {
  //   try {
  //     const response = await PropertiesApi.getListingPropertyTypes();
  //     if (response?.data) {
  //       setPropertyTypes(
  //         response?.data &&
  //           response?.data
  //             ?.filter((item) => item?.id != 15)
  //             ?.map((item) => {
  //               return {
  //                 ...item,
  //                 label: item?.name,
  //                 value: item?.id,
  //               };
  //             })
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  // const getDistrict = async (cityId) => {
  //   try {
  //     const { data, code } = await VisitorApi.getDistricts(cityId);
  //     if (code === 200 && data && Array.isArray(data) && data.length > 0) {
  //       setDistricts(
  //         data.map((dst) => ({
  //           ...dst,
  //           value: dst.id,
  //           label: language === "en" ? dst?.name_en : dst?.name_ar,
  //         }))
  //       );
  //     } else {
  //       setDistricts(
  //         cities?.filter((city) => parseInt(city?.value) === parseInt(cityId))
  //       );
  //     }
  //   } catch (error) {}
  // };

  // useEffect(() => {
  //   if (cityId) {
  //     getDistrict(cityId);
  //   }
  // }, [cityId, language]);

  // useEffect(() => {
  //   getPropertyTypes();
  // }, [language]);

  // const handleFileChange = async (files, onChange, name) => {
  //   if (!files || !files.length) return;
  //   // const MAX_SIZE = 5 * 1024 * 1024;
  //   const uploadedFiles = [];
  //   const currentFieldUploads = new Set(uploadedFilesMap[name]);

  //   setIsUploading(true);
  //   setUploadingType(name);

  //   for (const file of files) {
  //     if (currentFieldUploads.has(file.name)) continue;
  //     const fileExtension = file?.name?.split(".").pop().toLowerCase();
  //     const uniqueFileName = `attachment-${crypto.randomUUID()}.${fileExtension}`;

  //     try {
  //       // Chunked Upload
  //       const chunkSize = 5 * 1024 * 1024;
  //       const totalChunks = Math.ceil(file.size / chunkSize);
  //       let upload_id;
  //       let parts = [];

  //       for (let i = 0; i < totalChunks; i++) {
  //         const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);

  //         const {
  //           data: { presignedUrl, chunkKey, uploadId },
  //         } = await generatePresignedUrl(
  //           uniqueFileName,
  //           i,
  //           upload_id,
  //           file.type
  //         );

  //         if (!upload_id) upload_id = uploadId;
  //         const controller = new AbortController();
  //         abortControllersRef.current[file.name + i] = controller;

  //         const response = await axios.put(presignedUrl, chunk, {
  //           headers: {
  //             "Content-Type": "application/octet-stream",
  //           },
  //           signal: controller.signal,
  //         });

  //         parts.push({
  //           PartNumber: i + 1,
  //           ETag: response.headers.etag,
  //         });

  //         setProgress(Math.round((parts.length / totalChunks) * 100));
  //       }

  //       const fileUrl = await finalizeMultipartUpload(
  //         uniqueFileName,
  //         upload_id,
  //         parts
  //       );
  //       uploadedFiles.push(fileUrl);
  //       currentFieldUploads.add(file.name);
  //     } catch (err) {
  //       console.error("File upload failed for", file.name, err);
  //     }
  //   }

  //   setIsUploading(false);
  //   setUploadingType(null);
  //   setProgress(0);

  //   // Update the field with all uploaded files
  //   const field = watch(name);
  //   onChange(field ? [...field, ...uploadedFiles] : uploadedFiles);

  //   setUploadedFilesMap((prev) => ({
  //     ...prev,
  //     [name]: currentFieldUploads,
  //   }));
  // };

  // const generatePresignedUrl = async (
  //   fileName,
  //   chunkIndex,
  //   uploadId,
  //   file_type
  // ) => {
  //   const formData = {
  //     fileName,
  //     chunkIndex,
  //     file_type,
  //   };
  //   if (uploadId) {
  //     formData.uploadId = uploadId;
  //   }
  //   try {
  //     const response = await PropertiesApi.getPresignedURLs(formData);
  //     return response;
  //   } catch (error) {
  //     return;
  //   }
  // };

  // const finalizeMultipartUpload = async (fileName, uploadId, parts) => {
  //   try {
  //     const response = await PropertiesApi.finalizeUpload({
  //       fileName,
  //       uploadId,
  //       parts,
  //     });
  //     return response.data.fileUrl;
  //   } catch (error) {
  //     console.error("Error finalizing multipart upload:", error);
  //     throw error;
  //   }
  // };

  // const handleAddProperty = async (dataObj) => {
  //   try {
  //     setLoading(true);
  //     const formData = new FormData();
  //     formData.append("action", "create");
  //     // Object.entries(dataObj).forEach(([key, value]) => {
  //     //   if (key === "property_images" && Array.isArray(value)) {
  //     //     value.forEach((file) => {
  //     //       formData.append("property_images[]", file);
  //     //     });
  //     //   } else formData.append(key, value);
  //     // });
  //     const media = [];

  //     Object.entries(dataObj).forEach(([key, value]) => {
  //       if (
  //         [
  //           "exterior_images",
  //           "interior_images",
  //           "exterior_videos",
  //           "interior_videos",
  //         ].includes(key)
  //       ) {
  //         const config = mediaTypeCategoryMap[key];
  //         if (Array.isArray(value)) {
  //           value.forEach((file) => {
  //             media.push({
  //               file,
  //               type: config.type,
  //               category: config.category,
  //             });
  //           });
  //         }
  //       } else {
  //         formData.append(key, value);
  //       }
  //     });

  //     // Now append media[]
  //     media.forEach((mediaItem, index) => {
  //       formData.append(`media[${index}][file]`, mediaItem.file);
  //       formData.append(`media[${index}][type]`, mediaItem.type);
  //       formData.append(`media[${index}][category]`, mediaItem.category);
  //     });

  //     const { code, message } = await PropertiesApi.saveProperty(formData);
  //     if (code === 200) {
  //       toast.success(t("property_created_successfully"));
  //       props?.getPropertiesList();
  //       handleClose();
  //     }
  //     if (code === 100 || code === 204) {
  //       toast.error(message);
  //     }
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const citiesJson = localStorage.getItem("citiesList");
  const cities = citiesJson ? JSON.parse(citiesJson) : [];
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadingType, setUploadingType] = useState(null);
  const [progress, setProgress] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(0);

  const mediaTypeCategoryMap = {
    exterior_images: { type: 1, category: 1 },
    interior_images: { type: 1, category: 2 },
    exterior_videos: { type: 2, category: 1 },
    interior_videos: { type: 2, category: 2 },
  };

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  // Refs for managing upload state
  const uploadSessionIdRef = useRef(null);
  const abortControllersRef = useRef({});
  const isUploadingRef = useRef(false);
  const shouldAbortRef = useRef(false);

  const cityId = watch("city_id");
  const priceInput = watch("price");
  const propertyType = watch("listing_property_type_id");
  const [propertyTypes, setPropertyTypes] = useState(null);
  const [advertiserTypes, setAdvertiserTypes] = useState([]);

  // State: track uploaded file names per field
  const [uploadedFilesMap, setUploadedFilesMap] = useState({
    interior_images: new Set(),
    exterior_images: new Set(),
    interior_videos: new Set(),
    exterior_videos: new Set(),
  });

  // Clean up function to abort all uploads and reset state
  const cleanupUploads = () => {
    console.log("Cleaning up uploads...");

    // Set abort flag
    shouldAbortRef.current = true;

    // Abort all ongoing requests
    Object.values(abortControllersRef.current).forEach((controller) => {
      try {
        controller.abort();
      } catch (error) {
        console.log("Error aborting controller:", error);
      }
    });

    // Clear controllers
    abortControllersRef.current = {};

    // Reset upload state
    setIsUploading(false);
    setUploadingType(null);
    setProgress(0);
    isUploadingRef.current = false;

    // Reset uploaded files map
    setUploadedFilesMap({
      interior_images: new Set(),
      exterior_images: new Set(),
      interior_videos: new Set(),
      exterior_videos: new Set(),
    });

    // Invalidate upload session
    uploadSessionIdRef.current = null;
  };

  const handleClose = () => {
    console.log("Modal closing, cleaning up...");

    // Clean up uploads first
    cleanupUploads();

    // Reset form and trigger
    setResetTrigger((prev) => prev + 1);
    reset();

    // Close modal
    props.onHide();
  };

  // Reset shouldAbort flag when modal opens
  useEffect(() => {
    if (props.show) {
      shouldAbortRef.current = false;
    }
  }, [props.show]);

  const getAdvertiserTypes = async () => {
    try {
      const response = await PropertiesApi.getListingStatuses();
      const types = response?.data?.advertiser_types;
      if (Array.isArray(types)) {
        setAdvertiserTypes(
          types.map((item) => ({
            ...item,
            label: item?.label || item?.key,
            value: item?.key,
          }))
        );
      }
    } catch (error) {
      setAdvertiserTypes([]);
    }
  };

  const getPropertyTypes = async () => {
    try {
      const response = await PropertiesApi.getListingPropertyTypes();
      if (response?.data) {
        setPropertyTypes(
          response?.data &&
            response?.data
              ?.filter((item) => item?.id != 15)
              ?.map((item) => {
                return {
                  ...item,
                  label:
                    language === "en" ? item?.en_name : item?.ar_name,
                  value: item?.id,
                };
              })
        );
      }
    } catch (error) {
      console.log(error.message);
      setPropertyTypes([]);
    }
  };

  const getDistrict = async (cityId) => {
    try {
      const { data, code } = await VisitorApi.getDistricts(cityId);
      if (code === 200 && data && Array.isArray(data) && data.length > 0) {
        setDistricts(
          data.map((dst) => ({
            ...dst,
            value: dst.id,
            label: language === "en" ? dst?.name_en : dst?.name_ar,
          }))
        );
      } else {
        setDistricts(
          cities?.filter((city) => parseInt(city?.value) === parseInt(cityId))
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (cityId) {
      getDistrict(cityId);
    }
  }, [cityId, language]);

  useEffect(() => {
    getPropertyTypes();
    getAdvertiserTypes();
  }, [language]);

  const handleFileChange = async (files, onChange, name) => {
    if (!files || !files.length) return;

    if (shouldAbortRef.current) {
      return;
    }

    const currentFieldUploads = new Set(uploadedFilesMap[name]);
    const filesToUpload = Array.from(files).filter(
      (file) => !currentFieldUploads.has(file.name)
    );
    if (filesToUpload.length === 0) {
      return;
    }

    setIsUploading(true);
    setUploadingType(name);
    isUploadingRef.current = true;

    try {
      const uploadedPaths = await uploadPropertyMediaFiles(filesToUpload, {
        onProgress: setProgress,
        shouldAbort: () => shouldAbortRef.current,
      });

      if (!shouldAbortRef.current && uploadedPaths.length > 0) {
        filesToUpload.forEach((file) => currentFieldUploads.add(file.name));
        const field = watch(name);
        onChange(field ? [...field, ...uploadedPaths] : uploadedPaths);
        setUploadedFilesMap((prev) => ({
          ...prev,
          [name]: currentFieldUploads,
        }));
      }
    } catch (err) {
      if (!shouldAbortRef.current) {
        console.error("File upload failed:", err);
        toast.error(t("something_went_wrong") || err?.message);
      }
    } finally {
      if (!shouldAbortRef.current) {
        setIsUploading(false);
        setUploadingType(null);
        setProgress(0);
        isUploadingRef.current = false;
      }
    }
  };

  const handleAddProperty = async (dataObj) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("action", "create");

      const media = [];

      Object.entries(dataObj).forEach(([key, value]) => {
        if (
          [
            "exterior_images",
            "interior_images",
            "exterior_videos",
            "interior_videos",
          ].includes(key)
        ) {
          const config = mediaTypeCategoryMap[key];
          if (Array.isArray(value)) {
            value.forEach((file) => {
              media.push({
                file,
                type: config.type,
                category: config.category,
              });
            });
          }
        } else {
          formData.append(key, value);
        }
      });

      // Now append media[]
      media.forEach((mediaItem, index) => {
        formData.append(`media[${index}][file]`, mediaItem.file);
        formData.append(`media[${index}][type]`, mediaItem.type);
        formData.append(`media[${index}][category]`, mediaItem.category);
      });

      const { code, message } = await PropertiesApi.saveProperty(formData);
      if (code === 200) {
        toast.success(t("property_created_successfully"));
        props?.getPropertiesList();
        handleClose();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
      console.error("Error saving property:", error);
    } finally {
      setLoading(false);
    }
  };

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      cleanupUploads();
    };
  }, []);

  return (
    <Modal
      show={props?.show}
      onHide={handleClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit(handleAddProperty)}>
        <Modal.Header className="">
          <Modal.Title>
            <HeadingStyled size="24px" className="">
              {t("AddListing")}
            </HeadingStyled>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Box className="d-flex flex-column align-items-center py-3 px-2"> */}
          <Box className="formEleContainer">
            <Box className="w-100">
              <LabelStyled className="labelForm">
                {t("listing_type")}
                {/* <span className="staric">*</span> */}
              </LabelStyled>
              <Box className="w-100">
                <ValidationController
                  name={"listing_type"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <Box className="d-flex gap-2">
                      <Box className="w-100">
                        <CustomRadioButton
                          name="listing_type"
                          label={t("for_rent")}
                          value={1}
                          checked={1 == field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      </Box>
                      <Box className="w-100">
                        <CustomRadioButton
                          name="listing_type"
                          label={t("for_sale")}
                          value={2}
                          checked={2 == field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      </Box>
                    </Box>
                  )}
                />
              </Box>
            </Box>
          </Box>
          <Box className="formEleContainer">
            <Box className="w-100">
              <LabelStyled className="labelForm">
                {t("property_type")}
                {/* <span className="staric">*</span> */}
              </LabelStyled>
              <ValidationController
                name={"listing_property_type_id"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: `fieldRequired`,
                }}
                renderer={({ field }) => (
                  <Box className="mt-2">
                    <SelectionDropdown
                      name={"listing_property_type_id"}
                      placeholder={t("choose_type")}
                      value={field.value}
                      options={propertyTypes || []}
                      onChange={(e) => {
                        setValue("other_prop_type_en", "");
                        setValue("other_prop_type_ar", "");
                        field.onChange(e.target.value);
                      }}
                    />
                  </Box>
                )}
              />
              {propertyType && Number(propertyType) === 7 && (
                <>
                  <ValidatedInput
                    name="other_prop_type_en"
                    label={"other_en"}
                    type="input"
                    fieldType="text"
                    placeholder={"Other EN"}
                    className={"w-100 mb-0 combined flex-wrap p-0"}
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                  />
                  <ValidatedInput
                    name="other_prop_type_ar"
                    label={"other_ar"}
                    type="input"
                    fieldType="text"
                    placeholder={"أخرى (بالعربية)"}
                    className={"w-100 mb-0 combined flex-wrap p-0"}
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                  />
                </>
              )}
            </Box>
          </Box>
          <Box className="formEleContainer">
            <Box className="w-100">
              <LabelStyled className="labelForm">
                {t("AdvertiserType")}
              </LabelStyled>
              <ValidationController
                name={"advertiser_type"}
                control={control}
                errors={errors}
                validationConfig={{}}
                renderer={({ field }) => (
                  <Box className="mt-2">
                    <SelectionDropdown
                      name={"advertiser_type"}
                      placeholder={t("SelectAdvertiserType")}
                      value={field.value}
                      options={advertiserTypes || []}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  </Box>
                )}
              />
            </Box>
          </Box>
          <Box className="formEleContainer">
            <Box className="w-100">
              <LabelStyled className="labelForm">
                {t("property_status")}
                {/* <span className="staric">*</span> */}
              </LabelStyled>
              <Box className="w-100">
                <ValidationController
                  name={"property_status"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <Box className="d-flex gap-2">
                      <Box className="w-100">
                        <CustomRadioButton
                          name="property_status"
                          label={t("ready")}
                          value={1}
                          checked={1 == field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      </Box>
                      <Box className="w-100">
                        <CustomRadioButton
                          name="property_status"
                          label={t("off_plan")}
                          value={2}
                          checked={2 == field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                      </Box>
                    </Box>
                  )}
                />
              </Box>
            </Box>
          </Box>
          <Box className="d-flex gap-2 flex-sm-nowrap flex-wrap">
            <Box className="formEleContainer w-100">
              <LabelStyled className="labelForm">{t("City")}</LabelStyled>
              <ValidationController
                name={"city_id"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: `fieldRequired`,
                }}
                renderer={({ field }) => (
                  <SelectionDropdown
                    name={field.name}
                    placeholder={t("City")}
                    options={cities}
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
            </Box>
            <Box className="formEleContainer w-100">
              <LabelStyled className="labelForm">
                {t("Neighbourhood")}
              </LabelStyled>
              <ValidationController
                name={"neighborhood"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: `fieldRequired`,
                }}
                renderer={({ field }) => (
                  <SelectionDropdown
                    name={field.name}
                    placeholder={t("Neighbourhood")}
                    options={districts}
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
            </Box>
          </Box>

          <Box className="d-flex gap-2 flex-sm-nowrap flex-wrap">
            <Controller
              name="price"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value, ref },
                fieldState: { error },
              }) => (
                <ValidatedInput
                  name="price"
                  label={"price_sar"}
                  type="input"
                  fieldType="text" // must be text to allow formatting
                  placeholder={"price_sar"}
                  className={"w-100 mb-0 combined flex-wrap p-0"}
                  value={value ? formatAmountForDisplay(value) : ""}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const raw = inputValue.replace(/,/g, "");

                    // Allow empty, decimal point only, or valid decimal numbers with up to 2 decimal places
                    if (
                      raw === "" ||
                      raw === "." ||
                      /^\d*\.?\d{0,2}$/.test(raw)
                    ) {
                      onChange(raw);
                    }
                  }}
                  errors={{ price: error }}
                />
              )}
            />
            <ValidatedInput
              name="ad_number"
              label={"AdNumber"}
              type="input"
              fieldType="number"
              placeholder={"AdNumber"}
              className={"w-100 mb-0 combined flex-wrap p-0"}
              register={register}
              errors={errors}
              validationRules={{
                required: true,
                validate: (value) => {
                  const str = value.toString();
                  return (
                    /^7/.test(str) || t("validation_must_start_with_seven")
                  );
                },
              }}
            />
          </Box>

          <ValidatedInput
            name="contact_phone"
            label={"confirm_contact_number"}
            type="input"
            fieldType="tel"
            placeholder={"confirm_contact_number"}
            className={"w-100 mb-0 combined flex-wrap p-0"}
            register={register}
            errors={errors}
            validationRules={{}}
          />

          <ValidatedInput
            name="description_en"
            label={"description_en"}
            type="textarea"
            fieldType="textarea"
            placeholder={"Description EN (Maximum 200 words)"}
            className={"w-100 mb-0 combined flex-wrap p-0"}
            register={register}
            errors={errors}
            validationRules={{
              required: true,
              validate: (value) =>
                countWords(value) <= 200 || "max_200_words_allowed",
            }}
          />
          <TextStyled color="var(--text3)" size="14px">
            {t("recommended_num_of_rooms")}
          </TextStyled>
          <ValidatedInput
            name="description_ar"
            label={"description_ar"}
            type="textarea"
            fieldType="textarea"
            placeholder={"الوصف (بالإنجليزية) - بحد أقصى 200 كلمة"}
            className={"w-100 mb-0 combined flex-wrap p-0"}
            register={register}
            errors={errors}
            validationRules={{
              required: true,
              validate: (value) =>
                countWords(value) <= 200 || "max_200_words_allowed",
            }}
          />
          <TextStyled color="var(--text3)" size="14px">
            {t("recommended_num_of_rooms")}
          </TextStyled>

          {/* <Box className="formEleContainer">
            <Box>
              <LabelStyled className="labelForm">
                {t("AdPlatform")}
              </LabelStyled>
              <Box className="w-100 d-flex gap-2">
                <Box>
                  <CustomRadioButton
                    name="is_platform"
                    label={t("none")}
                    value={0}
                    checked={isPlatform == 0}
                    onChange={(e) => {
                      setValue("ad_platform", []);
                      setIsPlatform(e.target.value);
                    }}
                  />
                </Box>
                <Box>
                  <CustomRadioButton
                    name="is_platform"
                    label={t("AdPlatform")}
                    value={1}
                    checked={isPlatform == 1}
                    onChange={(e) => setIsPlatform(e.target.value)}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          {isPlatform == 1 && (
            <Box className="formEleContainer">
              <ValidationController
                name={"ad_platform"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: `fieldRequired`,
                }}
                renderer={({ field }) => (
                  <MultiSelectionDropdown
                    name={field.name}
                    placeholder={t("select_platforms")}
                    options={platforms}
                    value={field.value || []}
                    onChange={(selected) => field.onChange(selected)}
                  />
                )}
              />
            </Box>
          )} */}

          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm w-100">
              {t("exterior_images")}
            </LabelStyled>
            <ValidationController
              name={"exterior_images"}
              control={control}
              errors={errors}
              validationConfig={{
                required: false,
                // required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <MultipleImageUpload
                  onChange={(files) =>
                    handleFileChange(files, field.onChange, field.name)
                  }
                  onRemove={field.onChange}
                  selectedImages={field?.value?.map((val) => ({
                    id: val,
                    image: val,
                  }))}
                  max={20}
                  resetTrigger={resetTrigger}
                  isLoading={isUploading && uploadingType === "exterior_images"}
                  disabled={isUploading}
                />
              )}
            />

            <TextStyled color="var(--text3)" size="14px">
              {t("upload_upto_20_img")}
            </TextStyled>
          </Box>
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm w-100">
              {t("interior_images")}
            </LabelStyled>
            <ValidationController
              name={"interior_images"}
              control={control}
              errors={errors}
              validationConfig={{
                required: false,
                // required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <MultipleImageUpload
                  onChange={(files) =>
                    handleFileChange(files, field.onChange, field.name)
                  }
                  onRemove={field.onChange}
                  selectedImages={field?.value?.map((val) => ({
                    id: val,
                    image: val,
                  }))}
                  resetTrigger={resetTrigger}
                  isLoading={isUploading && uploadingType === "interior_images"}
                  disabled={isUploading}
                  max={50}
                />
              )}
            />
            <TextStyled color="var(--text3)" size="14px">
              {t("upload_upto_50_img")}
            </TextStyled>
          </Box>
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm w-100">
              {t("exterior_videos")}
            </LabelStyled>
            <ValidationController
              name={"exterior_videos"}
              control={control}
              errors={errors}
              validationConfig={{
                required: false,
                // required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <MultipleVideoUpload
                  onChange={(files) =>
                    handleFileChange(files, field.onChange, field.name)
                  }
                  selectedVideos={field?.value?.map((val) => ({
                    id: val,
                    video: val,
                  }))}
                  resetTrigger={resetTrigger}
                  onRemove={field.onChange}
                  isLoading={isUploading && uploadingType === "exterior_videos"}
                  disabled={isUploading}
                  max={4}
                />
              )}
            />
            <TextStyled color="var(--text3)" size="14px">
              {t("upload_upto_4_vid")}
            </TextStyled>
          </Box>
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm w-100">
              {t("interior_videos")}
            </LabelStyled>
            <ValidationController
              name={"interior_videos"}
              control={control}
              errors={errors}
              validationConfig={{
                required: false,
                // required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <MultipleVideoUpload
                  onChange={(files) =>
                    handleFileChange(files, field.onChange, field.name)
                  }
                  selectedVideos={field?.value?.map((val) => ({
                    id: val,
                    video: val,
                  }))}
                  resetTrigger={resetTrigger}
                  onRemove={field.onChange}
                  isLoading={isUploading && uploadingType === "interior_videos"}
                  disabled={isUploading}
                  maxDuration={180}
                  max={50}
                />
              )}
            />
            <TextStyled color="var(--text3)" size="14px">
              {t("upload_unlimited_vid")}
            </TextStyled>
          </Box>

          {/* </Box> */}
        </Modal.Body>
        <Modal.Footer className="">
          <FormButtonStyled
            label={t("Cancel")}
            className=""
            clName=""
            bg="transparent"
            shadow="false"
            color="var(--lightGrey)"
            onClick={handleClose}
            border="var(--border)"
            type="button"
          />
          <FormButtonStyled
            label={t("Publish")}
            className=""
            clName="mb-2"
            type="submit"
            bg="var(--themeColorSecondary)"
            disabled={loading}
            isLoading={loading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddPropertyModal;
